#### Email parsing retirement

We have retired the SEEK API’s legacy compatibility with email parsing integrations.
SEEK will no longer send plain-text job application emails to an email address nominated on the job ad or hirer account.
Note that this does not affect the rich HTML emails that can be configured on the [SEEK Employer website].

The `ApplicationMethodInput.applicationEmail` field is ignored when [posting][posting-a-job-ad] or [updating][updating-a-job-ad] a job ad.
Remove this field from your requests, even if you are sending a `null` value:

```diff
{
  "postingInstructions": [
-   {
-     "applicationEmail": null
-   }
  ]
}
```

The [`ApplicationMethod.applicationEmail`] field is \`null\`ed out when [querying][querying-a-job-ad] a job ad.
Remove this field from your requests:

```diff
query {
  positionProfile {
    postingInstructions {
      applicationMethods {
-       applicationEmail {
-         address
-       }
        applicationUri
      }
    }
  }
}
```

We are actively working with partners who are still sending non-compliant requests.
These fields will be formally removed from our GraphQL schema once remediation is complete.

[`applicationmethod.applicationemail`]: /schema/named-type/ApplicationMethod#/field/applicationEmail
[posting-a-job-ad]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad
[querying-a-job-ad]: /use-cases/job-posting/managing-job-ads/querying-a-job-ad
[seek employer website]: https://employer.seek.com
[updating-a-job-ad]: /use-cases/job-posting/managing-job-ads/updating-a-job-ad
